// extracted by mini-css-extract-plugin
export default {"container":"DroneWarning_container__SkGy+","text":"DroneWarning_text__jtRSG","title":"DroneWarning_title__P2m2Z"};